// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"38af90c3","453":"7cbf262e","455":"4b454d3d"}[chunkId] + ".chunk.js";
};